import React from 'react';
import './background.css';




function Background() {
  return (
    <div>    
        <div id='stars'></div>
        <div id='stars2'></div>
        <div id='stars3'></div>
        <div id='title'>
        </div>
    </div>  
  );
}

export default Background;